import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import AssignmentIcon from '@mui/icons-material/Assignment';
import TableChartIcon from '@mui/icons-material/TableChart';
import { useTranslation } from 'react-i18next';

interface NoTourModalProps {
  open: boolean;
  onClose: () => void;
}

export const NoTourModal = ({ open, onClose }: NoTourModalProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'no-tour-modal' });

  return (
    <Dialog
      aria-describedby='no-tour-dialog-description'
      aria-labelledby='no-tour-dialog-title'
      open={open}
      onClose={onClose}
    >
      <DialogTitle id='no-tour-dialog-title'>
        {t('title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id='no-tour-dialog-description'>
          {t('description')}
        </DialogContentText>
        <List
          dense
          sx={{ mt: 1 }}
        >
          <ListItem>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <HomeIcon fontSize='small' />
            </ListItemIcon>
            <ListItemText primary={t('home')} />
          </ListItem>
          <ListItem>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <TableChartIcon fontSize='small' />
            </ListItemIcon>
            <ListItemText primary={t('account')} />
          </ListItem>
          <ListItem>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <ManageSearchIcon fontSize='small' />
            </ListItemIcon>
            <ListItemText primary={t('advanced_search')} />
          </ListItem>
          <ListItem>
            <ListItemIcon sx={{ minWidth: 32 }}>
              <AssignmentIcon fontSize='small' />
            </ListItemIcon>
            <ListItemText primary={t('applications')} />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          onClick={onClose}
        >
          {t('close_btn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
